import type { ReactNode } from "react";

export function WithSidebar(props: { children: ReactNode }) {
  return <div className="with-sidebar">{props.children}</div>;
}